import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { staticMenu } from "./staticMenu.jsx";
import { IconButton } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import ListItemLinkContainer from "./ListContainer/ListItemLinkContainer.jsx";
import { useStyles } from "./MuiCSS/MiniDrawerStyles.jsx";
import Navbar from "../Navbar.js";
export const drawerWidth = 340;

const MiniDrawer = (props) => {
  const classes = useStyles();

  const handlerSideBar = () => {
    props.handleSideBar();
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Navbar />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: props.sideBar,
          [classes.drawerClose]: !props.sideBar,
        })}
        classes={{
          paper: `${clsx({
            [classes.drawerOpen]: props.sideBar,
            [classes.drawerClose]: !props.sideBar,
          })} ${classes.drawerPaper}`,
        }}
        open={props.sideBar}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handlerSideBar}>
            {!props.sideBar ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>

        <Divider />
        <nav className={classes.lists}>
          <List>
            {staticMenu.map((menu, index) => (
              <React.Fragment key={index}>
                <ListItemLinkContainer
                  menuObj={menu}
                  openSideBar={props.sideBar}
                />
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </nav>
      </Drawer>
    </React.Fragment>
  );
};

export default MiniDrawer;
